// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure the IonContent takes the full height of the screen */
.ion-content {
  --background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  --background-size: cover;
  position: relative;

  /* Full height of the viewport */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  height: 100vh; /* Full viewport height */
  padding: 0;
}

/* Make sure the IonGrid takes the full height */
.ion-grid {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%; /* Full height inside content */
}

/* Top button aligned to the top of the screen */
.top-button {
  width: 100%;
  max-width: 400px;
  margin-top: 20px;
}

/* Bottom button aligned to the bottom of the screen */
.bottom-button {
  width: 100%;
  max-width: 400px;
  margin-bottom: 20px;
}

/* Logo centered in the middle */
.logo-container {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo {
  max-width: 200px;
  max-height: 200px;
  margin: 20px 0;
}

/* Button styling */
.square-button {
  border-radius: 10px;
  padding: 15px;
  font-size: 1.2em;
  width: 100%; /* Make the button take full width by default */
  height: 75px; /* Ensure buttons have sufficient height */
}

.square-button:hover {
  background-color: #ffffff;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
  transform: translateY(-5px);
}

.square-button ion-text {
  color: white;
}

/* Media query for larger screen sizes (desktops) */
@media (min-width: 768px) {
  /* Adjust size of the top button */
  .top-button {
    margin-top: 50px; /* Increased margin for desktop */
    max-width: none; /* Remove max-width limit */
  }

  /* Adjust size of the bottom button */
  .bottom-button {
    margin-bottom: 50px; /* Increased margin for desktop */
    max-width: none; /* Remove max-width limit */
  }

  /* Adjust button size for larger screens */
  .square-button {
    padding: 30px; /* Increased padding for desktop */
    font-size: 1.5em; /* Larger font size for desktop */
    width: 100%; /* Ensure buttons take full width */
    height: 150px; /* Double the height on larger screens */
  }

  /* Adjust hover effect for larger screens */
  .square-button:hover {
    background-color: #ffffff;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    transform: translateY(-8px);
  }

  /* Increase logo size for desktop */
  .logo {
    max-width: 300px; /* Larger logo for desktop */
    max-height: 300px; /* Larger logo for desktop */
  }

  /* Ensure IonCol spans full width */
  .ion-col {
    flex: 1 1;
    max-width: 100%; /* Full width on desktops */
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/HomeSelection.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,6EAAqE;EACrE,wBAAwB;EACxB,kBAAkB;;EAElB,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;EACpB,aAAa,EAAE,yBAAyB;EACxC,UAAU;AACZ;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY,EAAE,+BAA+B;AAC/C;;AAEA,gDAAgD;AAChD;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW,EAAE,+CAA+C;EAC5D,YAAY,EAAE,0CAA0C;AAC1D;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA,mDAAmD;AACnD;EACE,kCAAkC;EAClC;IACE,gBAAgB,EAAE,iCAAiC;IACnD,eAAe,EAAE,2BAA2B;EAC9C;;EAEA,qCAAqC;EACrC;IACE,mBAAmB,EAAE,iCAAiC;IACtD,eAAe,EAAE,2BAA2B;EAC9C;;EAEA,0CAA0C;EAC1C;IACE,aAAa,EAAE,kCAAkC;IACjD,gBAAgB,EAAE,iCAAiC;IACnD,WAAW,EAAE,mCAAmC;IAChD,aAAa,EAAE,wCAAwC;EACzD;;EAEA,2CAA2C;EAC3C;IACE,yBAAyB;IACzB,0CAA0C;IAC1C,2BAA2B;EAC7B;;EAEA,mCAAmC;EACnC;IACE,gBAAgB,EAAE,4BAA4B;IAC9C,iBAAiB,EAAE,4BAA4B;EACjD;;EAEA,mCAAmC;EACnC;IACE,SAAO;IACP,eAAe,EAAE,2BAA2B;EAC9C;AACF","sourcesContent":["/* Ensure the IonContent takes the full height of the screen */\n.ion-content {\n  --background: url(\"../assets/background.jpg\") no-repeat center center;\n  --background-size: cover;\n  position: relative;\n\n  /* Full height of the viewport */\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: stretch;\n  height: 100vh; /* Full viewport height */\n  padding: 0;\n}\n\n/* Make sure the IonGrid takes the full height */\n.ion-grid {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%; /* Full height inside content */\n}\n\n/* Top button aligned to the top of the screen */\n.top-button {\n  width: 100%;\n  max-width: 400px;\n  margin-top: 20px;\n}\n\n/* Bottom button aligned to the bottom of the screen */\n.bottom-button {\n  width: 100%;\n  max-width: 400px;\n  margin-bottom: 20px;\n}\n\n/* Logo centered in the middle */\n.logo-container {\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.logo {\n  max-width: 200px;\n  max-height: 200px;\n  margin: 20px 0;\n}\n\n/* Button styling */\n.square-button {\n  border-radius: 10px;\n  padding: 15px;\n  font-size: 1.2em;\n  width: 100%; /* Make the button take full width by default */\n  height: 75px; /* Ensure buttons have sufficient height */\n}\n\n.square-button:hover {\n  background-color: #ffffff;\n  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);\n  transform: translateY(-5px);\n}\n\n.square-button ion-text {\n  color: white;\n}\n\n/* Media query for larger screen sizes (desktops) */\n@media (min-width: 768px) {\n  /* Adjust size of the top button */\n  .top-button {\n    margin-top: 50px; /* Increased margin for desktop */\n    max-width: none; /* Remove max-width limit */\n  }\n\n  /* Adjust size of the bottom button */\n  .bottom-button {\n    margin-bottom: 50px; /* Increased margin for desktop */\n    max-width: none; /* Remove max-width limit */\n  }\n\n  /* Adjust button size for larger screens */\n  .square-button {\n    padding: 30px; /* Increased padding for desktop */\n    font-size: 1.5em; /* Larger font size for desktop */\n    width: 100%; /* Ensure buttons take full width */\n    height: 150px; /* Double the height on larger screens */\n  }\n\n  /* Adjust hover effect for larger screens */\n  .square-button:hover {\n    background-color: #ffffff;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n    transform: translateY(-8px);\n  }\n\n  /* Increase logo size for desktop */\n  .logo {\n    max-width: 300px; /* Larger logo for desktop */\n    max-height: 300px; /* Larger logo for desktop */\n  }\n\n  /* Ensure IonCol spans full width */\n  .ion-col {\n    flex: 1;\n    max-width: 100%; /* Full width on desktops */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
